// extracted by mini-css-extract-plugin
export var alertIcon = "_s1-0";